export default function PHP_warning_count() {
  return (
    <div>
      <h1>PHP_warning_count</h1>
    </div>
  );
}
